<template>
  <div>
    <!-- Process table -->
    <div class="card pagination-margin"
         qid="processes-section"
    >
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="float-left" qid="processes-table-title">
              {{ $t('maintenance.policies.tab.processes') }}
            </h5>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('processes.table.name') }}
            </th>
            <th scope="col">
              {{ $t('processes.table.owners') }}
            </th>
            <th scope="col">
              {{ $t('processes.table.tags') }}
            </th>
            <th scope="col">
              {{ $t('processes.table.process_group') }}
            </th>
            <th scope="col">
              {{ $t('system.last_updated') }}
            </th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="object in tableItems">
              <td>
                <router-link
                    :to="{ name: 'processes.view', params: { slug: object.process.slug }}"
                    qid="p-view-page-link"
                    v-if="object.process.client == getClient.slug"
                >
                  {{object.process.name}}
                </router-link>
                <button v-if="object.process.client != getClient.slug"
                        class="btn btn-link btn-sm"
                        @click="openNoticeModal(object.process)"
                >
                  {{ object.process.name }}
                </button>
              </td>
              <td>
                <span class="mr-1" v-for="user in getReducedUsers(object.process.users)">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="object.process.users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(object.process)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ object.process.users.length - 3 }}
                </span>
              </td>
              <td>
                <span class="mr-1" v-for="tag in getReducedTags(object.process.tags_translated)" qid="p-tags-list">
                  <span class="badge mb-1" :title="tag.name_translated">
                    <font-awesome-icon icon="tag"/>
                    {{tag.name_translated | truncate(35)}}
                  </span>
                </span>
                <span v-if="object.process.tags_translated.length > 3"
                      class="badge cursor-pointer"
                      @click="openTagsModal(object.process)"
                >
                  <font-awesome-icon icon="tags"/>
                  + {{ object.process.tags_translated.length - 3 }}
                </span>
              </td>
              <td>
                <span v-if="object.process.process_group"
                      class="badge"
                >
                  <font-awesome-icon icon="project-diagram"/>
                  {{ object.process.process_group.name }}
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ object.process.updated_at | formatDate }}
                </span>
              </td>
            </tr>
            <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                        v-model="perPage"
                        :options="perPageOptions"
                        track-by="value"
                        label="value"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-org-form-organization-level"
                        @select="perPageChanged"
                        :placeholder="selectedPerPage"
                        @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="selectedPerPage"
                    aria-controls="my-table"
                    @change="pageChanged"
                    limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>

    </div>


    <!-- Delete process modal template -->
    <b-modal ref="delete-process" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-ac-title">
          {{ $t('activities.process.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.process.delete.description') }}
        <span v-if="itemToDelete">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.process.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideSConfirmDeleteModal"
                  qid="delete-ac-cancel-button"
        >
          {{ $t('activities.process.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteS(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-ac-submit-button"
        >
          {{ $t('activities.process.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ShowMoreModal
        :items="selectedItem.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

    <PartitionNoticeModal
        :item="selectedItem"
        state="processes.view"
        :show="showNoticeModal"
        @closeViewModal="closeNoticeModal"
    ></PartitionNoticeModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  import Avatar from '@/components/Avatar.vue';
  import PartitionNoticeModal from '@/components/PartitionNoticeModal.vue';


  export default {
    name: 'ProcessTable',
    data: function() {
      return {
        sForm: {
          system_role: '',
          rules_followed: '',
          data_objects: []
        },

        // Process
        tableItems: [],
        selectedP: [],
        viewSModal: false,
        selectedSSort: '',
        selectedSDirection: '',
        pItems: [],

        error: '',
        loadingItems: false,
        itemToDelete: {},
        itemObject: {},
        showSDescription: false,
        buttonDisabled: false,
        selectedItem: {},
        showTagsModal: false,
        showUsersModal: false,

        currentPage: 1,
        totalRows: 0,
        loading: true,
        perPage: '',
        selectedPerPage: "10",
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' },
        ],
        showNoticeModal: false,
        selectedItem: {}
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      }
    },
    components: {
      Avatar,
      ShowMoreModal,
      PartitionNoticeModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      object: function (value) {
        this.loadContent()
      }
    },
    methods: {
      showCreateSModal() {
        this.$refs['add-process'].show()
      },
      openTagsModal(object) {
        this.selectedItem = object
        this.showTagsModal = true
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      openNoticeModal(object) {
        this.selectedItem = object
        this.showNoticeModal = true
      },
      closeNoticeModal() {
        this.selectedItem = {}
        this.showNoticeModal = false
      },
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
        return reducedUsers;
      },
      hideCreateSModal() {
        this.error = ''
        this.selectedP = []
        this.loadContent()
        this.$refs['add-process'].hide()
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-process'].show()
      },
      hideSConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-process'].hide()
      },
      openViewSModal(object) {
        this.selectedP = object
        this.viewSModal = true
      },
      handleCloseViewSModal () {
        this.selectedP = []
        this.viewSModal = false;
      },
      pageChanged(page) {
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        this.loadContent(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)
      },
      loadContent(page, perPage) {
        let self = this;

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        if (this.object && this.object.id) {
          piincHttp.get('policies/' + this.object.slug + '/processes', { params:
            {
              page: pageNumber,
              per_page: perPageNumber,
              client: this.getClient.slug
            }
          }).then(function (response) {
            self.loading = false;
            self.tableItems = response.data.items;
            // Set number of total items
            self.totalRows = response.data.total_count;
          }, function () {
          });
        }
      }
    },
    created () {
      this.activity = this.object;
      // Table items
      this.loadContent();
    }
  }
</script>
